import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/Homepage'
import EventDetail from '@/components/EventDetail'
import EventList from '@/components/EventList'
import GameDetail from '@/components/GameDetail'
import GameList from '@/components/GameList'
import AdminView from '@/components/AdminView'
import ProfileView from '@/components/ProfileView'
import HelpPage from '@/components/parts/HelpPage'

Vue.use(Router)

function adminUser(to, from, next){
  if(Vue.$isAdmin()) {
    return next()
  }
  next('/')
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/evenements/',
      component: EventList,
    },
    {
      path: '/evenement/:id',
      component: EventDetail,
    },
    {
      path: '/jeu/:name',
      component: GameDetail,
    },
    {
      path: '/ludotheque',
      component: GameList,
    },
    {
      path: '/administration',
      component: AdminView,
      beforeEnter: adminUser,
    },
    {
      path: '/profil',
      component: ProfileView,
    },
    {
      path: '/aide',
      component: HelpPage,
    },
    {
      path: '/',
      component: Homepage,
    },
    { path: '*', redirect: '/' }
  ],
})
